<template>
  <div id="app" :class="{'no-scroll':this.$store.state.mobileMenuActive}">
    <!--        <div id="nav">-->
    <!--            <router-link to="/">Home</router-link>-->
    <!--            |-->
    <!--            <router-link :to="{name:'PhotosPage'}">Photos</router-link>-->
    <!--            |-->
    <!--            <router-link :to="{name:'VideosPage'}">Videos</router-link>-->
    <!--            |-->
    <!--            <router-link to="/about">About</router-link>-->
    <!--        </div>-->
    <transition name="fade">
      <div v-if="flasherActive" class="intro-flasher">
        <div>
        <img :src="flasherImagePath" alt="" style="height: 100%;width: 100%;object-fit: contain;max-width: 200px;">
        </div>
      </div>
    </transition>
    <div class="nav-links-wrapper" :class="[{'navbar-hidden':navbarHidden},{'navbar-shadow':navbarShadow}]">
      <b-container fluid>
        <b-row>
          <b-col cols="12">
            <div class="navbar-content-wrapper">


              <router-link to="/">
                <img v-on:click="handleLogoClick" :src="navbarLeftLogoPath" alt="" style="height: 6em;">
              </router-link>
              <div class="d-flex flex-column align-items-center" style="justify-self: center;">
                <router-link to="/">
                  <img v-on:click="handleLogoClick" :src="navbarMiddleLogoPath" style="height: 4em;object-fit: contain;" alt="">
                </router-link>
                <div class="d-flex justify-content-between">
                  <router-link class="nav-link navigation-link" :to="{name:'PhotosPage'}">Stills</router-link>
                  <router-link class="nav-link navigation-link" :to="{name:'VideosPage'}">Motion</router-link>
                  <router-link class="nav-link navigation-link" to="/about">Info</router-link>
                </div>

              </div>
              <div></div>


              <!--          <router-link class="nav-link" to="/">-->
              <!--            <img :src="navbarLeftLogoPath" alt="" style="height: 100%;">-->
              <!--          </router-link>-->
              <!--          <div>-->
              <!--            <router-link class="nav-link" to="/">-->
              <!--              <img :src="navbarMiddleLogoPath" alt="" style="height: 100%; width: 6em;">-->
              <!--            </router-link>-->
              <!--            <div>-->
              <!--              <router-link class="nav-link" :to="{name:'PhotosPage'}">Stills</router-link>-->
              <!--              <router-link class="nav-link" :to="{name:'VideosPage'}">Motion</router-link>-->
              <!--              <router-link class="nav-link" to="/about">Info</router-link>-->
              <!--            </div>-->
              <!--          </div>-->
              <!--          <div>-->
              <!--            tst-->
              <!--          </div>-->
            </div>
          </b-col>
        </b-row>
      </b-container>

    </div>



    <!--    <b-container fluid>-->
    <!--      <b-row>-->
    <!--        <b-col cols="12">-->
    <!--          <div class="d-flex justify-content-between">-->
    <!--            <div>leftlogo</div>-->
    <!--            <div>midlogo</div>-->
    <!--            <div>rightmargin</div>-->
    <!--          </div>-->
    <!--        </b-col>-->
    <!--      </b-row>-->
    <!--    </b-container>-->


    <router-view style="padding-top:10em;"/>
<!--    <div class="mobile-menu" :class="{'active':this.$store.state.mobileMenuActive}">-->
<!--      <b-container fluid class="h-100">-->
<!--        <div class="d-flex align-items-center justify-content-center flex-column text-left h-100">-->
<!--          <router-link class="nav-link mobile-link" to="/">Home</router-link>-->
<!--          <router-link class="nav-link mobile-link" :to="{name:'PhotosPage'}">Photos</router-link>-->
<!--          <router-link class="nav-link mobile-link" :to="{name:'VideosPage'}">Videos</router-link>-->
<!--          <router-link class="nav-link mobile-link" to="/about">About</router-link>-->
<!--          <div class="mobile-menu-close-button" @click="closeNavMenu">-->
<!--            [close]-->
<!--          </div>-->
<!--        </div>-->
<!--      </b-container>-->
<!--    </div>-->
  </div>
</template>
<script>
import axios from 'axios'

export default {
  name: 'Approot',
  data() {
    return {
      flasherImagePath: null,
      navbarMiddleLogoPath: null,
      navbarLeftLogoPath: null,
      flasherActive: true,
      navbarHidden: false,
      navbarShadow: false
    }
  },
  methods: {
    openNavMenu: function () {
      this.$store.commit('activateMobileMenu')
    },
    closeNavMenu: function () {
      this.$store.commit('deactivateMobileMenu')
    },
handleLogoClick:function (){
      if (this.$route.name=='Home'){
        window.scrollTo({top: 0, behavior: 'smooth'});
      }

}
  },
  watch: {
    '$route'(to, from) {
      this.$store.commit('deactivateMobileMenu')

    }
  },
  mounted() {
    this.$store.dispatch('GET_APPCONTENT_FROM_API')

    this.$nextTick(function () {

      var apiPath = process.env.VUE_APP_API_URL

      axios.get(`${apiPath}/appcontent`).then(res => {
        this.flasherImagePath = apiPath + res.data.flasherlogo.url
        this.navbarMiddleLogoPath = apiPath + res.data.navbarmiddlelogo.url
        this.navbarLeftLogoPath = apiPath + res.data.navbarleftlogo.url
        setTimeout(() => {
          this.flasherActive = false
        }, 2000);
      })


    })

    var oldScrollPos = 0

    window.onscroll = () => {
      if (window.scrollY > 200) {
        //add shadow
        this.navbarShadow=true
      } else {
        this.navbarShadow=false
      }

      if (window.scrollY > oldScrollPos && window.scrollY > 200) {
        this.navbarHidden = true
      } else if (window.scrollY < oldScrollPos) {
        this.navbarHidden = false

      }

      oldScrollPos = window.scrollY
    }

  }
}
</script>
<style lang="scss">
@import "custom.scss";

#app {
  font-family: 'Barlow Condensed', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}





.intro-flasher {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100vw;
  height: 100vh;
  background-color: $custom-bgcolor;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.navbar-content-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}

.nav-links-wrapper {
  justify-content: center;
  padding: 1em 0em;
  margin-bottom: 1em;
  position: fixed;
  top: 0;
  z-index: 100;
  left: 0;
  width: 100%;
  background: $custom-bgcolor;
  transition: top .5s;
}

.navbar-shadow{
  box-shadow: rgba(0, 0, 0, 0.5) 0px 2px 2px 0px;

}

.navbar-hidden{
  top: -20em;
}

.mobile-menu-wrapper {

}

.mobile-menu-button {
  cursor: pointer;
}

.mobile-menu-close-button {
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
}

.mobile-menu {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 0;
  background-color: $custom-bgcolor;
  transition: height .3s;
  visibility: hidden;

  &.active {
    height: 100%;
    visibility: visible;

  }
}

.no-scroll {
  height: 100vh;
  overflow: hidden;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}


@include media-breakpoint-down(xs) {
  //.nav-links-wrapper {
  //  display: none;
  //}

}
</style>
